export default __webpack_public_path__ + "static/media/home-bg.e00d986b.png";